import React, { useState, useEffect } from "react";
import Aside from "../../../components/Aside";
import Api from "../../../services/api";
import swal from "sweetalert";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { Link, useParams } from "react-router-dom";
import NewFoto from "./new";
import EditFoto from "./edit";
import ReactTooltip from "react-tooltip";

export default function UnidadesFotos() {
  const { unidade } = useParams();
  const [loading, setLoading] = useState(true);
  const Loader = () => <div className="loading"></div>;
  const [infosUnidade, setInfosUnidade] = useState([]);
  const [fotos, setFotos] = useState([]);
  const [openModalNew, setOpenModalNew] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [fotoEdit, setFotoEdit] = useState([]);

  useEffect(() => {
    loadInfoUnidade();
    loadFotosUnidade();
  }, []);

  function loadInfoUnidade() {
    Api.get("/unidades/" + unidade)
      .then((response) => {
        setInfosUnidade(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  function loadFotosUnidade() {
    Api.get("/unidades/fotos/" + unidade)
      .then((response) => {
        setFotos(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  function editFoto(foto) {
    setFotoEdit(foto);
    setOpenModalEdit(true);
  }

  function setCapa(foto) {
    if (foto.is_capa) return;
    setLoading(true);
    Api.post("/unidades/fotos/capa/" + foto.id)
      .then(() => {
        loadFotosUnidade();
      })
      .catch((err) => {
        swal("Erro ao definir capa: " + err, { icon: "error" });
        setLoading(false);
      });
  }

  function deleteFoto(foto) {
    swal({
      title: "Excluir foto",
      text: "Deseja realmente excluir a foto selecionada ?",
      icon: "warning",
      html: true,
      buttons: ["Cancelar", "Excluir"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        Api.delete("/unidades/fotos/delete/" + foto.id)
          .then((response) => {
            swal(response.data.message, {
              icon: "success",
            });
            loadFotosUnidade();
            setLoading(false);
          })
          .catch((err) => {
            swal("ops! ocorreu um erro" + err, {
              icon: "success",
            });
            setLoading(false);
          });
      }
    });
  }

  function renderTopPage() {
    return (
      <div className="top">
        <div>
          <span className="text">
            Fotos da Unidade / {infosUnidade[0].nome}
          </span>
          <ul className="breadcrumbs">
            <li>Fotos da Unidade / {infosUnidade[0].nome}</li>
            <li>Fotos</li>
          </ul>
        </div>
        <div>
          <div className="actions top">
            <Link
              to="#"
              onClick={() => {
                setOpenModalNew(true);
              }}
            >
              <i className="bx bx-plus-circle"></i> Foto
            </Link>
            <Link
              to={`/unidades/${unidade}/order`}
              onClick={() => {
                setOpenModalNew(true);
              }}
            >
              <i className="bx bx-plus-circle"></i> Ordenação
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const RenderContent = () => {
    useEffect(() => {
      ReactTooltip.rebuild();
    });

    const rows = fotos.map((foto) => {
      const imagem = () => {
        return (
          foto.imagem && (
            <img src={process.env.REACT_APP_FILES_URL + foto.imagem_thumb_1} />
          )
        );
      };

      return (
        <div
          className={`item${foto.is_capa ? " is-capa" : ""}`}
          key={foto.id}
          style={
            foto.is_capa
              ? {
                  outline: "3px solid #f5b400",
                  outlineOffset: "-3px",
                  position: "relative",
                }
              : { position: "relative" }
          }
        >
          {foto.is_capa && (
            <span
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                background: "#f5b400",
                color: "#fff",
                fontWeight: 700,
                fontSize: 11,
                letterSpacing: 0.5,
                padding: "3px 8px",
                borderRadius: 4,
                zIndex: 2,
                boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
              }}
            >
              CAPA
            </span>
          )}
          <div>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setCapa(foto);
              }}
              data-tip={foto.is_capa ? "Imagem de capa" : "Definir como capa"}
              style={{ color: foto.is_capa ? "#f5b400" : undefined }}
            >
              <i className={foto.is_capa ? "bx bxs-star" : "bx bx-star"}></i>
            </a>
            <a
              href="#"
              onClick={() => {
                editFoto(foto);
              }}
              alt="Editar"
              data-tip="Editar"
            >
              <i className="bx bx-edit"></i>
            </a>
            <a
              href="#"
              onClick={() => {
                deleteFoto(foto);
              }}
              data-tip="Excluir"
            >
              <i className="bx bx-trash"></i>
            </a>
          </div>
          <div>{imagem()}</div>
        </div>
      );
    });

    return (
      <>
        <div className="grid fotos">
          <div className="content">{rows}</div>
        </div>
      </>
    );
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <ReactTooltip effect="solid" />
      <div className="container-box">
        <Aside />
        <main>
          {infosUnidade[0] && renderTopPage()}
          {fotos && RenderContent()}
        </main>
      </div>

      <Modal
        open={openModalNew}
        onClose={() => {
          setOpenModalNew(false);
        }}
        classNames={{
          overlay: "customOverlay",
          modal: "customModal",
        }}
      >
        <NewFoto
          unidadeId={unidade}
          loadFotosUnidade={loadFotosUnidade}
          setOpenModalNew={setOpenModalNew}
        />
      </Modal>

      <Modal
        open={openModalEdit}
        onClose={() => {
          setOpenModalEdit(false);
        }}
        classNames={{
          overlay: "customOverlay",
          modal: "customModal",
        }}
      >
        <EditFoto
          data={fotoEdit}
          loadFotosUnidade={loadFotosUnidade}
          setOpenModalEdit={setOpenModalEdit}
        />
      </Modal>
    </>
  );
}
